import React from 'react';
import { Marker } from "react-google-maps";

const LopChuQuyen = () => {
    return (
        <div>
            <Marker
                icon={{
                    path:
                        'M12.75 0l-2.25 2.25 2.25 2.25-5.25 6h-5.25l4.125 4.125-6.375 8.452v0.923h0.923l8.452-6.375 4.125 4.125v-5.25l6-5.25 2.25 2.25 2.25-2.25-11.25-11.25zM10.5 12.75l-1.5-1.5 5.25-5.25 1.5 1.5-5.25 5.25z',
                    fillColor: '#0000ff',
                    fillOpacity: 0,
                    strokeWeight: 0,
                    scale: 0
                }}
                draggable={false}
                label={{
                    text: 'QUẦN ĐẢO HOÀNG SA (VIỆT NAM)',
                    color: 'white',
                    fontWeight: 'bold'
                }}
                // position={{ lat: 15.499425, lng: 114.413184 }}
                position={{ lat: 15.803773, lng: 114.386787 }}
            />
            <Marker
                icon={{
                    path:
                        'M12.75 0l-2.25 2.25 2.25 2.25-5.25 6h-5.25l4.125 4.125-6.375 8.452v0.923h0.923l8.452-6.375 4.125 4.125v-5.25l6-5.25 2.25 2.25 2.25-2.25-11.25-11.25zM10.5 12.75l-1.5-1.5 5.25-5.25 1.5 1.5-5.25 5.25z',
                    fillColor: '#0000ff',
                    fillOpacity: 0,
                    strokeWeight: 0,
                    scale: 0
                }}
                draggable={false}
                label={{
                    text: 'QUẦN ĐẢO TRƯỜNG SA (VIỆT NAM)',
                    color: 'white',
                    fontWeight: 'bold'
                }}
                position={{ lat: 11.180792, lng: 115.789213 }}
            />
        </div>
    )
}
export default LopChuQuyen;
